<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Auth from './services/Auth'
import EventEmitter from './services/EventEmitter'
export default {
  name: 'app',
  created () {
    // wywolaj /api/my aby sprawdzic czy login działa

    Auth.my().then(
      res => {
        Auth.setUser(res.data.user)
        EventEmitter.$emit('user.get', res.data.user)
      },
      () => {
        this.$router.push({
          name: 'login'
        })
      }
    )
  }
}
</script>

<style lang="scss">

.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;  /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}

@import "./assets/css/main.scss";
@import "../node_modules/keen-ui/dist/keen-ui.css";

</style>



// WEBPACK FOOTER //
// App.vue?2571a017